export default __webpack_public_path__ + "static/media/youtube_line.aa004d24.svg";